import { SETTINGS_DIALOG } from '../types';
import { TEST_DIALOG } from '../types';

const defaultDialogs = {
  settings: null,
  test: null,
}

export default function reducer(state = defaultDialogs, action) {
  switch (action.type) {
    case SETTINGS_DIALOG:
      return { ...state, settings: action.payload };
    case TEST_DIALOG:
      return { ...state, test: action.payload };
    default:
      break;
  }
  return state;
}

